import {TranslateService} from '@ngx-translate/core';

export class MailReturn
{
  externId: number;

  x3Id: string;
  objectName: string;
  objectId: number;
  objectValue: string;

  mail: string;
  mailDate: Date;
  statusCode: string;
  reason: string;

  public static getText(item: MailReturn, translate: TranslateService): string
  {
    if (item.statusCode)
    {
      const translated = translate.instant(item.statusCode);
      if (translated && translated !== item.statusCode)
        return translated;
    }
    return item.reason;
  }
}
